export enum WS_MESSAGE_TYPE {
  EXPORT_LOT = 'EXPORT_LOT',
  IMPORT_LOT = 'IMPORT_LOT',
  EXPORT_PROPOSAL = 'EXPORT_PROPOSAL',
  LOT_INFOCARD = 'LOT_INFOCARD',
  PARSE_EXCEL_PROPOSAL = 'PARSE_EXCEL_PROPOSAL',

  TENDER = 'tender',
  TENDER_COUNTER = 'TENDER_COUNTER',
  ACL_DECISIONS = 'ACL_DECISIONS',

  EXPORT_TENDER_ADDITIONAL_CRITERIA = 'EXPORT_TENDER_ADDITIONAL_CRITERIA',
  IMPORT_TENDER_ADDITIONAL_CRITERIA = 'IMPORT_TENDER_ADDITIONAL_CRITERIA',
  EXPORT_FORMULA_PRICES = 'EXPORT_FORMULA_PRICES',
  IMPORT_FORMULA_PRICES = 'IMPORT_FORMULA_PRICES',
  CREATE_INFOCARD = 'CREATE_INFOCARD',
  CREATE_PROTOCOL = 'CREATE_PROTOCOL',

  EXPORT_RATINGS = 'EXPORT_RATINGS',

  KONTUR_FOCUS = 'KONTUR_FOCUS',

  EXPORT_PROPOSAL_INFOCARD = 'EXPORT_PROPOSAL_INFOCARD',
  EXPORT_ACCREDITATION_REPORT = 'EXPORT_ACCREDITATION_REPORT',
  EXPORT_SECURITY_FORMATION_CONCLUSION = 'EXPORT_SECURITY_FORMATION_CONCLUSION',

  PRICE_GUIDE = 'PRICE_GUIDE',

  IMPORT_ALL_DECISION = 'IMPORT_ALL_DECISION',
  IMPORT_CAM_DECISION = 'IMPORT_CAM_DECISION',
  EXPORT_CAM_DECISION = 'EXPORT_CAM_DECISION',
}
